import { QRCodeReaderPackage } from '@sysmobil/synoro-packages';
import { CircularProgress } from '@mui/material';
import { useCurrentUserInfo } from 'js/library/services/currentUserInfo';
import cfac22 from 'js/library/utils/cfac22';

export function QRCodeReader() {
  const { userInfo: user, loading } = useCurrentUserInfo();

  if (loading || !user) {
    return <CircularProgress />;
  }

  return (
    <QRCodeReaderPackage
      uId={Object.hasOwn(user, 'temporary') ? undefined : user.uId}
      triiboId={user.triiboId}
      bgColor={'#6f2d9a'}
      ambient={cfac22('ambient')}
      projectName={cfac22('PROJECT_NAME')}
      clubName={'Triibo'}
    />
  );
}
